import * as React from 'react'

import getConfig from 'next/config'

import { AuthProvider, Routes, Types as AuthTypes } from '@grandvisionhq/auth'

type AuthConfig = React.ComponentProps<typeof AuthProvider>['settings']

const { publicRuntimeConfig } = getConfig()
const apiUrl = publicRuntimeConfig.grandvision.apiUrl ?? ''
const { auth0Domain, auth0CustomDomain, auth0ClientId } =
  publicRuntimeConfig.grandvision.myAccount ?? {}

const routes: Routes = {
  appointments: 'appointments',
  changePassword: 'change-password',
  createAccount: 'create',
  linkExpired: 'link-expired',
  login: 'login',
  logout: 'logout',
  orders: 'orders',
  prescriptions: 'prescriptions',
  profile: 'profile',
  resetPassword: 'reset-password',
  setPassword: 'set-password',
  settings: 'settings',
  signup: 'signup',
  subscriptions: 'subscriptions',
  unlinkOrder: 'unlink-order',
  verify: 'verify',
  wishlist: 'wishlist',
}

const optIns: AuthTypes.OptInItem[] = [
  {
    titleKey: 'account.optIn.marketingEmails',
    value: 'marketingEmails',
    isInSignup: true,
  },
]

const supportFeaturesLinks: AuthTypes.SupportFeatureLink[] = [
  {
    label: 'account.menu.appointments',
    url: routes.appointments,
  },
  {
    label: 'account.menu.orders',
    url: routes.orders,
  },
  {
    label: 'account.menu.subscriptions',
    url: routes.subscriptions,
  },
  {
    label: 'account.menu.settings',
    url: routes.settings,
  },
]

export const getAuthConfig = (): AuthConfig => ({
  apiUrl,
  basePath: 'my-account',
  clientId: auth0ClientId,
  customDomain: auth0CustomDomain,
  domain: auth0Domain,
  routes,
  optIns,
  checkoutRoute: '/checkout/expedition',
  supportFeaturesLinks,
})
